var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","min-height":"100vh","overflow":"auto"},attrs:{"id":"block_settings_page_container"}})}
var staticRenderFns = []

export { render, staticRenderFns }